"use client";
import {NeoButton} from "@/components/forms";
import {useNeoContext} from "@/context/neo/neo.context";
import {Button} from "@nextui-org/react";
import {ChangeEvent, useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import toast from "react-hot-toast";
import Select from "react-select";

interface DashboardFilterProps {
  onSubmit: any;
  searchinstitutes: any;
}

export const DashboardFilter: React.FC<DashboardFilterProps> = ({
  onSubmit,
  searchinstitutes
}) => {
  const {clients} = useNeoContext();
  const [dashboardInstitutes, setDashboardInstitutes] = useState<any>([]);
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: {isSubmitting, errors}
  } = useForm<any>({
    mode: "onChange"
  });

  useEffect(() => {
    /*let instituteusers:any = [];
    if(clients){
      clients.forEach((e: any, index: number) => {
        instituteusers.push(e.institutionUserId)
      });
    }*/
    if (searchinstitutes.length > 0) {
      setDashboardInstitutes(searchinstitutes);
      instituteUserids();
    }
  }, [clients]);

  const InstitutionChange = (e: ChangeEvent<HTMLSelectElement>) => {
    let userids: any = [];
    const value = e.target.value;
    if (value) {
      userids = value.split(",");
    }
    setDashboardInstitutes(userids);
    instituteUserids();
  };

  const instituteUserids = () => dashboardInstitutes;
  const clientOptions =
    clients?.map((c: any) => ({
      label: c.institutionName,
      value: String(c.institutionUserId)
    })) || [];
  const onSubmitEvent = (event: any) => {
    if (dashboardInstitutes.length > 0) {
      onSubmit(dashboardInstitutes);
    } else {
      toast.error("Please select institution");
    }
  };
  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          onSubmitEvent(event);
        })}
      >
        <div className="flex flex-col gap-1 p-2">
          <div className="col-span-4 py-2 lg:col-span-1">
            <Controller
              control={control}
              name="institution"
              render={({field}) => {
                const selectedOptions = clientOptions.filter((opt: any) =>
                  dashboardInstitutes.includes(opt.value)
                );

                const handleChange = (selected: any) => {
                  const userIds = selected.map((item: any) => item.value);
                  field.onChange(userIds);
                  setDashboardInstitutes(userIds);
                };

                const handleSelectAll = () => {
                  const allIds = clientOptions.map((opt: any) => opt.value);
                  field.onChange(allIds);
                  setDashboardInstitutes(allIds);
                };

                const handleDeselectAll = () => {
                  field.onChange([]);
                  setDashboardInstitutes([]);
                };

                return (
                  <div className="flex flex-col gap-2 rounded-2xl border border-gray-300 p-4">
                    <div className="m-2 mb-1 flex justify-between">
                      Institution
                      <div className="flex gap-2">
                        <Button
                          size="sm"
                          className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                          onPress={handleSelectAll}
                        >
                          Select All
                        </Button>
                        <Button
                          size="sm"
                          onPress={handleDeselectAll}
                          className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                        >
                          Deselect All
                        </Button>
                      </div>
                    </div>
                    <Select
                      isMulti
                      options={clientOptions}
                      value={selectedOptions}
                      onChange={handleChange}
                      placeholder="Select institution(s)..."
                      classNamePrefix="react-select"
                      closeMenuOnSelect={false}
                      isClearable={false}
                      styles={{
                        control: base => ({
                          ...base,
                          minHeight: "40px",
                          borderColor: "#d4d4d8",
                          boxShadow: "none",
                          "&:hover": {
                            borderColor: "#d4d4d8"
                          }
                        }),
                        valueContainer: base => ({
                          ...base,
                          maxHeight: "100px",
                          overflowY: "auto",
                          flexWrap: "wrap"
                        }),
                        multiValue: base => ({
                          ...base,
                          backgroundColor: "white",
                          border: "1px solid #d4d4d8",
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }),
                        multiValueLabel: base => ({
                          ...base,
                          color: "#131313"
                        }),
                        multiValueRemove: base => ({
                          ...base,
                          color: "#131313",
                          ":hover": {
                            backgroundColor: "#d4d4d8",
                            color: "#131313"
                          }
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused
                            ? "#d4d4d8"
                            : "white",
                          color: "#000",
                          cursor: "pointer"
                        })
                      }}
                    />
                  </div>
                );
              }}
            />
          </div>
          <div className="flex justify-center">
            <NeoButton type="submit" color="yellow" className="text-lg">
              Submit
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
